import React from 'react'
import { Box, Button, Space } from 'UILibrary'

const Done = props => (
  <Box display="flex" flexDirection="column" alignItems="center">
    <Box debug width="50px" height="50px" />
    <Space size="xl" />
    <Box width="75%" textAlign="center">
      Your email address has been successfully verified
    </Box>
    <Space size="l" />
    <Button form back>
      BACK TO LOGIN
    </Button>
  </Box>
)

export default Done



// WEBPACK FOOTER //
// ./src/features/authentication/components/Done.js